import React, { useEffect, useState } from "react";

// JS Files
import Navbar from "../../shares/Navbar";
import Footer from "../../shares/Footer";
import SearchBox from "./SearchBox";
import Status from "./Status";

// Others File
import noDataIcon from "../../../imgs/no-data.svg";

const FollowupTakmili = () => {
  const [status, setStatus] = useState();
  return (
    <>
      <div className="hp-section-one">
        <Navbar />
      </div>
      <div className="mt-10 md:mt-12 mx-4 md:mx-16 mb-2">
        <p className="header">پیگیری ثبت‌نام بیمه درمان تکمیلی</p>
        <SearchBox setStatus={setStatus} />
       
      </div>
      <Footer />
    </>
  );
};
export default FollowupTakmili;
